import React, { FC, useEffect, useRef, useState } from 'react';
import s from './Timer.module.scss'; // your styles

function formatTime(ms: number) {
  const minutes = Math.floor(ms / 6000);
  const seconds = Math.floor((ms % 6000) / 100);
  const milliseconds = ms % 100;
  return {
    m: String(minutes).padStart(2, '0'),
    s: String(seconds).padStart(2, '0'),
    ms: String(milliseconds).padStart(2, '0'),
  };
}

export const Timer: FC = () => {
  const [currentTime, setCurrentTime] = useState(0);
  const animationRef = useRef<number>();
  const startRef = useRef<number>();
  const offsetRef = useRef<number>(0); // in ms

  useEffect(() => {
    // @ts-ignore
    window.stopwatch = true;

    const update = (timestamp: number) => {
      if (!startRef.current) startRef.current = timestamp;
      const elapsed = timestamp - startRef.current + offsetRef.current;

      const timeUnits = Math.floor(elapsed / 10); // count in 10ms units
      setCurrentTime(timeUnits);

      // @ts-ignore
      window.timer = formatTime(timeUnits);

      animationRef.current = requestAnimationFrame(update);
    };

    animationRef.current = requestAnimationFrame(update);

    return () => {
      cancelAnimationFrame(animationRef.current!);
      // @ts-ignore
      window.stopwatch = undefined;
    };
  }, []);

  const formattedTime = formatTime(currentTime);

  return (
    <div className={s.timer}>
      <span className={s.m}>{formattedTime.m}</span>:
      <span className={s.s}>{formattedTime.s}</span>:
      <span className={s.ms}>{formattedTime.ms}</span>
    </div>
  );
};